// -----------------------------------------------------
// -----------------    AUDIO PLAYER    --------------------
// -----------------------------------------------------

export function drive_audioPlayer() {
  let audioButton = jQuery('.about_audio_button');
  let audioPlayer = jQuery('.about_audio_player');
  let audioSpan = jQuery('.audio__button_span');
  audioButton.click(function () {
    if (audioPlayer.prop('paused')) {
      audioPlayer.trigger('play');
      audioSpan?.addClass('aPause');
    } else {
      audioPlayer.trigger('pause');
      audioSpan.removeClass('aPause');
      audioSpan?.addClass('aPlay');
    }
  });
}

// -----------------------------------------------------
// -----------------    Trainers Info    --------------------
// -----------------------------------------------------

export function drive_trainersInfo() {
  let buttons = document.querySelectorAll('.trainers'),
    blocks = document.querySelectorAll('.team_main');

  [...buttons][0]?.classList.add('current');
  [...blocks][0]?.classList.add('active');

  [...buttons].forEach((it, idx) => {
    it.addEventListener('click', () => {
      [...buttons].map((item) => {
        item.classList.remove('current');
      });
      [...blocks].map((item) => {
        item.classList.remove('active');
      });

      it.classList.add('current');
      [...blocks][idx].classList.add('active');
    });
  });
}

// -----------------------------------------------------
// -----------------    Scroll Top    --------------------
// -----------------------------------------------------
export function drive_top() {
  var button = jQuery('.fa-arrow-alt-circle-up');
  //button.fadeOut();
  jQuery(window).scroll(function () {
    if (jQuery(this).scrollTop() > 300) {
      button.fadeIn();
    } else {
      button.fadeOut();
    }
  });
  button.on('click', function () {
    jQuery('body, html').animate(
      {
        scrollTop: 0,
      },
      800
    );
    return false;
  });
}

// -----------------------------------------------------
// -----------------    Counter    --------------------
// -----------------------------------------------------

export function drive_counter(cl, target) {
  var show = true;
  var countbox = cl;
  jQuery(window).on('scroll load resize', function () {
    if (!show) return false;

    var w_top = jQuery(window).scrollTop();
    var e_top = jQuery(countbox)?.offset()?.top;

    var w_height = jQuery(window).height();
    var d_height = jQuery(document).height();

    var e_height = jQuery(countbox).outerHeight();

    if (
      w_top + 800 >= e_top ||
      w_height + w_top == d_height ||
      e_height + e_top < w_height
    ) {
      jQuery(target).countTo();
      show = false;
    }
  });
}

// -----------------------------------------------------
// -----------------    Venobox    --------------------
// -----------------------------------------------------

export function drive_venobox() {
  jQuery('.venobox_custom').venobox({
    border: '4px',
    bgcolor: '#ffffff',
    spinner: 'spinner-pulse',
    cb_pre_open: function () {
      document.documentElement.style.overflow = 'hidden';
    },
    cb_pre_close: function () {
      document.documentElement.style.overflow = '';
    },
  });
  jQuery('.venobox_custom_click').venobox({
    bgcolor: false,
    cb_pre_open: function () {
      document.documentElement.style.overflow = 'hidden';
    },
    cb_pre_close: function () {
      document.documentElement.style.overflow = '';
    },
  });
  jQuery('.venobox_custom_click').click(function () {
    return false;
  });
}

// -----------------------------------------------------
// -----------------    Rotate    --------------------
// -----------------------------------------------------
export function drive_rotate() {
  const circle = document.querySelector('.outside_circle');
  if (!circle) {
    return;
  }
  let angle = 0;
  function rotate() {
    angle += 0.1; // Увеличиваем угол (скорость вращения можно менять)
    circle.style.transform = `translate(-50%, -50%) rotate(${angle}deg)`;
    requestAnimationFrame(rotate);
  }
  rotate();
}

// -----------------------------------------------------
// -----------------    Accordion    --------------------
// -----------------------------------------------------

export function drive_faq() {
  let buttons = document.querySelectorAll('[data-question-button]'),
    hideBlocks = document.querySelectorAll('[data-hide]');

  buttons.forEach((item, index) => {
    item.addEventListener('click', () => {
      [...hideBlocks][index].classList.toggle('active');
    });
  });
}

// -----------------------------------------------------
// -----------------    SeeAll    --------------------
// -----------------------------------------------------

export function seeAll(btn, block, speedvis, speedhide) {
  let btn_viewAll = document.querySelectorAll(btn);
  let blocks = document.querySelectorAll(block);

  btn_viewAll.forEach((it, ind) => {
    it.addEventListener('click', function () {
      [...blocks][ind].classList.toggle('active-info');
      it.classList.toggle('active');

      if (it.classList.contains('active')) {
        setTimeout(() => {
          it.textContent = 'Свернуть';
        }, speedvis);
      } else {
        setTimeout(() => {
          it.textContent = 'Развернуть';
        }, speedhide);
      }
    });
  });
}

// -----------------------------------------------------
// -----------------    Banner    --------------------
// -----------------------------------------------------

export function banner() {
  let banner = document?.querySelector('.banner'),
    contentSidebar = document?.querySelector('.content'),
    clickTop = document?.querySelector('.drive_top');

  if (banner) {
    contentSidebar.classList.add('content-sidebar');
    if (window.innerWidth <= 1023) {
      clickTop.style.display = 'none';
    }

    window.addEventListener('scroll', function () {
      let imgCoordBottom = document
        ?.getElementsByTagName('img')[0]
        .getBoundingClientRect().bottom;

      if (imgCoordBottom <= 50) {
        banner.classList.add('banner-fixed');
        if (window.innerWidth > 1440) {
          banner.style.left =
            contentSidebar.getBoundingClientRect().right + 80 + 'px';
        } else if (window.innerWidth > 1024) {
          banner.style.left =
            contentSidebar.getBoundingClientRect().right + 75 + 'px';
        }
      } else {
        banner.classList.remove('banner-fixed');
        banner.style.left = 'initial';
      }

      if (
        banner.getBoundingClientRect().bottom >
        contentSidebar.getBoundingClientRect().bottom
      ) {
        banner.style.opacity = 0;
      } else {
        banner.style.opacity = 1;
      }
    });
  }

  function popUp() {
    let button = document.querySelector('.banner__button-click'),
      overlay = document.querySelector('.popup__overlay'),
      close = document.querySelectorAll('.close'),
      body = document.body,
      popup = document.querySelector('.popup');

    document.addEventListener('click', (event) => {
      if (event.target.closest('.popup__prevent')) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    });

    button?.addEventListener('click', (e) => {
      popup.classList.add('popup-active');
      overlay.classList.add('popup__overlay_active');
      body.classList.add('scroll-lock');
    });

    close.forEach((item) => {
      item.addEventListener('click', () => {
        popup.classList.toggle('popup-active');
        overlay.classList.toggle('popup__overlay_active');
        body.classList.remove('scroll-lock');
      });
    });
  }

  popUp();
}

// -----------------------------------------------------
// -------------    HideMobileHeader    ----------------
// -----------------------------------------------------

export function hideMobileHeader() {
  function trackScroll() {
    let sidebar = document.querySelector('sidebar'),
      zaglav = document.querySelector('.zaglav'),
      logo = document.querySelector('.logo'),
      topFooter = document.getElementById('footer').getBoundingClientRect().top,
      bottomHeader = document
        .querySelector('sidebar')
        .getBoundingClientRect().bottom;

    if (topFooter <= bottomHeader) {
      sidebar.classList.add('hide');
      zaglav.classList.add('hide');
      logo.classList.add('hide');
    } else {
      sidebar.classList.remove('hide');
      zaglav.classList.remove('hide');
      logo.classList.remove('hide');
    }
  }

  window.addEventListener('scroll', trackScroll);
}

// -----------------------------------------------------
// -------------    BeliefsTrain    ----------------
// -----------------------------------------------------

export function logicForm() {
  let n = 0,
    questions = {},
    firstPart = '',
    radioButtons = '',
    secondPart = '',
    choise = '',
    percent = 20,
    arr = [],
    flag = '',
    li = '',
    buttons = document.querySelector('.beliefs-form__bottom')?.children,
    ul = document.querySelector('.beliefs-stydy'),
    problemArea = document.querySelector('.problem-area'),
    problemButton = document.querySelector('.problem-area__button'),
    problemFields = document.querySelectorAll('.problem-area__field'),
    problemHint = document.querySelector('.problem-area__p'),
    buttonField = document.querySelector('.beliefs-form__bottom'),
    problemAreaHidden = document.querySelector('.problem-area__hidden'),
    inputField = document.querySelectorAll('.beliefs-form__input'),
    answerField = document.querySelector('.beliefs-form__answer'),
    counterField = document.querySelector('.beliefs-counter__count'),
    fillerField = document.querySelector('.beliefs-counter__filler'),
    questionField = document.querySelector('.beliefs-form__p'),
    fieldQuestion = document.querySelector('.beliefs-form__question'),
    choiseButton = document.querySelector('.beliefs__choise'),
    choiseParagraf = document.querySelector('.beliefs-form__top-p'),
    choiseTopArea = document.querySelector('.beliefs-form__top'),
    counter = document.querySelector('.beliefs-counter');

  logicAreaForm();
  changingBeliefs();
  toggleFirstSecondForm();

  function changingBeliefs() {
    document.querySelector('.beliefs')?.addEventListener('input', (e) => {
      e.target.value = capitalizeFirstLetter(e.target.value);
    });

    [...inputField].forEach((it) => {
      it.oninput = function (e) {
        flag = [...inputField].every((item) => {
          return item.value !== '';
        });
        if (flag) {
          it.addEventListener('keydown', (e) => {
            if (e.keyCode == 13 && !e.shiftKey) {
              e.preventDefault();
              e.stopImmediatePropagation();
              [...buttons][1].click();
            }
          });
          setTimeout(() => {
            buttonField.classList.remove('hidden');
          }, 100);
        } else {
          buttonField.classList.add('hidden');
        }

        this.classList.contains('beliefs-form__input_first')
          ? (firstPart = this.value)
          : '';
        this.classList.contains('beliefs-form__input_second')
          ? (secondPart = this.value)
          : '';

        questions = {
          1: [
            'Что означает для Вас <strong>"' +
              firstPart +
              '"</strong>? Что Вы под этим подразумеваете? Что конкретное? Какие особенности? <br>' +
              'Что означает для Вас <strong>"' +
              lowercaseFirstLetter(secondPart) +
              '"</strong>? Как вы это подразумеваете? Что конкретное? Какие особенности?',
          ],
          2: [
            'Откуда вы знаете, что <strong>"' +
              firstPart +
              ' ' +
              lowercaseFirstLetter(secondPart) +
              '"</strong>? Что вы видите, слышите, чувствуете, когда думаете об этом убеждении?',
          ],
          3: [
            'Каким новым словом или значением можно заменить -  <strong>"' +
              firstPart +
              '"</strong>, чтобы сохранить его смысл, но наделить новым позитивным значением?<br> Каким новым словом или значением можно заменить -  <strong>"' +
              lowercaseFirstLetter(secondPart) +
              '"</strong>, чтобы сохранить его смысл, но наделить новым позитивным значением?',
          ],
          4: [
            'Для чего Вам думать, что <strong>"' +
              firstPart +
              ' ' +
              lowercaseFirstLetter(secondPart) +
              '"</strong>? Что Вы получаете для себя, когда верите в это убеждение?',
          ],
          5: [
            'К какому другому положительному результату, чем <strong>"' +
              lowercaseFirstLetter(secondPart) +
              '"</strong> может привести это убеждение?',
          ],
          6: [
            'К чему это все приведет, если Вы и дальше будете продолжать верить в то, что <strong>"' +
              firstPart +
              ' ' +
              lowercaseFirstLetter(secondPart) +
              '"</strong>?',
          ],
          7: [
            'Что есть гораздо важне чем <strong>"' +
              lowercaseFirstLetter(secondPart) +
              '"</strong>?',
          ],
          8: [
            'Полезно ли Вам думать, что <strong>"' +
              firstPart +
              ' ' +
              lowercaseFirstLetter(secondPart) +
              '"</strong>? Делает ли это убеждению вашу жизнь лучше?',
          ],
          9: [
            'Как бы Вы думали, если бы у Вас вообще не было бы этого убеждения? Во, что бы Вы верили?',
          ],
          10: [
            'Итак, сейчс вы можете просмотреть все Ваши ответы и задать себе последний вопрос - Во что бы Вы решили поверить вместо старого убеждения? Каким другим, более полезным, убеждением его можно заменить?',
          ],
        };
      };
    });

    answerField?.addEventListener('keydown', (e) => {
      if (e.keyCode == 13 && !e.shiftKey) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (answerField.value !== '') {
          if (n < 11) {
            n++;
          } else {
            return;
          }

          if (n >= 2) {
            renderList(n);
          }
          changePercent(n);
          setConditionals(n);
        }
      }
    });

    [...buttons].forEach((it) => {
      it.addEventListener('keydown', (e) => {
        if (e.keyCode == 13 && !e.shiftKey) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      });

      it.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();

        if (it.classList.contains('next')) {
          if (n >= 1 && n < 11 && answerField.value == '') {
            return false;
          }
          if (n < 11) {
            n++;
          } else {
            location.reload();
          }

          if (n >= 2) {
            renderList(n);
          }
          changePercent(n);
          setConditionals(n);
        } else {
          if (n >= 2) {
            n--;
            removeItemList(n);
          }
          changePercent(n);
          setConditionals(n);
        }
      });
    });
  }

  function renderList(n) {
    if (n == 2) {
      li = ` <li class="beliefs-stydy__li">
            <p class="beliefs-stydy__question">Ваше убеждение: &nbsp;<span class="beliefs-red">${
              firstPart + ' ' + secondPart
            }</span></p></li>
            <li class="beliefs-stydy__li">
            <p class="beliefs-stydy__question">${
              n - 1 + '.'
            } Вопрос: &nbsp;<span>${questions[n - 1]}</span></p>
            <p class="beliefs-stydy__answer">Ответ: <br>&nbsp;<span class="beliefs-red">${
              document.querySelector('.beliefs-form__answer').value
            }</span></p>
            </li>`;
    } else if (
      n == 11 &&
      document.querySelector('.beliefs-stydy__last-title') == null
    ) {
      li = ` 
          <li class="beliefs-stydy__li">
            <p class="beliefs-stydy__last-title">Хорошая работа!</p>
            <p class="beliefs-stydy__question">Ваше старое убеждение: &nbsp;<span class="beliefs-red">${
              firstPart + ' ' + lowercaseFirstLetter(secondPart)
            }</span></p>
            <p class="beliefs-stydy__answer">Ваше новое убеждение: &nbsp;<span class="beliefs-red">${
              document.querySelector('.beliefs-form__answer').value
            }</span></p>
            <p class="beliefs-stydy__last-p">Сейчас, когда у Вас уже есть новое убеждение взамен старого, Вы можете окончательно закрепить проработку проделав следующее:<br><br>
            <span>1.</span> Подумайте или вспомните состояние, в котором ваша каждая клетка тела говорит «Нет». Как вы это чувствуете внутри? Усильте это состояние и заякорьте его любым удобным способом (прикосновением, звуком, образом, символом, словом).<br><br>
            <span>2.</span> Ощущая это мощное состояние «Нет», примените его к вашему ограничивающему убеждению. Продолжайте говорить ему «Нет» до тех пор, пока не почувствуете, что оно уже больше не имеет силы и вы в него не верите.<br><br>
            <span>3.</span> Войдите в состояние «Да». Подумайте или вспомните состояние, в котором ваша каждая клетка тела говорит «Да». Почувствуйте это «Да». Как оно отличается от «Нет»? Усильте это состояние и заякорьте его любым удобным способом (прикосновением, звуком, образом, символом, словом).<br><br>
            <span>4.</span> Ощущая это мощное состояние «Да», примените его к вашей новой полезной мысли, которую вы выбрали на шаге 2. Продолжайте говорить ей «Да» до тех пор, пока не появится стойкое ощущение, что она становится частью вашей жизни.
            </p>
            </li>  
            `;
    } else if (
      n == 11 &&
      document.querySelector('.beliefs-stydy__last-title') !== null
    ) {
      return;
    } else {
      li = ` <li class="beliefs-stydy__li">
            <p class="beliefs-stydy__question">${
              n - 1 + '.'
            } Вопрос: &nbsp;<span>${questions[n - 1]}</span></p>
            <p class="beliefs-stydy__answer">Ответ: <br>&nbsp;<span class="beliefs-red">${
              document.querySelector('.beliefs-form__answer').value
            }</span></p>
            </li>`;
    }

    ul.insertAdjacentHTML('beforeend', li);
    answerField.value = '';
  }

  function removeItemList(n) {
    [...ul.children].map((it, idx) => {
      if (idx == n) {
        getPrevAnswer(it);
        if (n == 1) {
          [...ul.children][0].remove();
        }
        it.remove();
      }
    });
  }

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  function lowercaseFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
  }

  function getPrevAnswer(it) {
    if (typeof it !== 'undefined') {
      if (n < 10) {
        answerField.value = it.children[1].children[1].textContent;
      }
      if (n == 10) {
        answerField.value = it.children[2].children[0].textContent;
      }
    }
  }

  function setConditionals(n) {
    if (n > 0) {
      questionField.classList.add('visible');
      answerField.classList.add('visible');
      counter.classList.remove('hidden');
    } else {
      questionField.classList.remove('visible');
      answerField.classList.remove('visible');
    }
    if (n == 1) {
      scrollToElem(document.querySelector('.beliefs-form'), 'start');
    }
    if (n >= 1) {
      choiseParagraf.innerHTML =
        'Ваше убеждение: <span>' +
        [...inputField][0].value +
        ' ' +
        lowercaseFirstLetter([...inputField][1].value) +
        '</span>';
      fieldQuestion.classList.add('visible');
      choiseTopArea.classList.add('hidden');
    }
    if (n > 1) {
      [...buttons][0].classList.add('visible');
      ul.children[0].classList.remove('hidden');
    } else {
      [...buttons][0].classList.remove('visible');
    }
    if (n > 10) {
      questionField.classList.remove('visible');
      [...buttons][1].textContent = 'Проработать новое?';
      answerField.classList.remove('visible');
      counter.classList.add('hidden');

      scrollToElem(ul, 'start');

      [...ul.children].map((it, idx) => {
        if (idx >= 0 && idx < 10) {
          it.classList.add('hidden');
        }
      });
    } else {
      [...ul.children].map((it, idx) => {
        if (idx >= 0 && idx < 10) {
          it.classList.remove('hidden');
        }
      });
      [...buttons][1].classList.remove('hidden');
      [...buttons][1].textContent = 'Далее';
    }

    questionField.children[0].innerHTML = questions[n];
  }

  function changePercent(n) {
    arr.push(n - 1);
    let lastElement = arr[arr.length - 1];
    let penultimateElement = arr[arr.length - 2];

    if (n > 1) {
      if (lastElement > penultimateElement) {
        percent += 10;
        fillerField.style.width = percent + '%';
        counterField.textContent = n;
      } else {
        percent -= 10;
        fillerField.style.width = percent + '%';
        counterField.textContent = n;
      }
    } else if (n == 11) {
      fillerField.style.width = '100%';
    } else {
      counterField.textContent = 1;
      percent -= 10;
      fillerField.style.width = '10%';
    }
  }

  function logicAreaForm() {
    [...problemFields][0]?.addEventListener('keydown', (e) => {
      if (e.keyCode == 13 && !e.shiftKey) {
        if (e.target.value === '') {
          problemButton.disabled = true;
          return false;
        } else {
          e.preventDefault();
          e.stopImmediatePropagation();

          problemAreaHidden.classList.add('visible');
          problemArea.children[0].innerHTML =
            'Проблемная область:&nbsp; <span>' +
            [...problemFields][0].value +
            '</span>';
          scrollToElem(document.querySelector('.beliefs-form'), 'start');
          setTimeout(() => {
            document.getElementById('header').classList.add('header-hidden');
          }, 500);
        }
      }
    });
    [...problemFields][1]?.addEventListener('keydown', (e) => {
      if (e.keyCode == 13 && !e.shiftKey) {
        if (e.target.value == '') {
          problemButton.disabled = true;
          return false;
        } else {
          problemButton.disabled = false;
          scrollToElem(ul, 'start');
        }
        e.preventDefault();
        e.stopImmediatePropagation();

        problemButton.click();
        if (n >= 1) {
          problemHint.classList.add('visible');
        }
      }
    });

    problemButton?.addEventListener('click', (e) => {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
      e.preventDefault();
      e.stopImmediatePropagation();
      n++;
      renderListCheckbox();
      [...problemFields][1].value = '';

      radioButtons = ul.querySelectorAll('.beliefs-radio');
      checkedRadio(radioButtons);
    });

    function checkedRadio(radioButtons) {
      [...radioButtons].forEach((it) => {
        it.onclick = (e) => {
          choise = e.target.nextSibling.nextSibling.textContent;
          choiseButton.classList.add('visible');
          scrollToElem(choiseButton, 'center');
        };
      });
    }
  }

  function renderListCheckbox() {
    if (n > 1) {
      li = ` <li class="beliefs-stydy__li">
          <p class="beliefs-stydy__answer"><input class="beliefs-radio" type="radio" name="choice"/>&nbsp;<span>${
            [...problemFields][1].value
          }</span></p>
          </li>`;
    } else {
      li = ` <li class="beliefs-stydy__li beliefs-stydy__li_first">
          <p class="beliefs-stydy__question">Проблемная область: &nbsp;<span>${
            [...problemFields][0].value
          }</span></p>
          <p class="beliefs-stydy__answer"><input class="beliefs-radio" type="radio" name="choice"/>&nbsp;<span>${
            [...problemFields][1].value
          }</span></p>
          </li>`;
    }

    ul.insertAdjacentHTML('beforeend', li);
  }

  function toggleFirstSecondForm() {
    choiseButton.addEventListener('click', () => {
      problemButton.disabled = true;
      choiseParagraf.classList.add('visible');
      choiseParagraf.children[0].textContent = '"' + choise + '"';
      [choiseButton, problemArea].map((it) => {
        if (it.classList.contains('visible')) {
          it.classList.remove('visible');
        }
        it.classList.add('hidden');
      });

      [...ul.children].map((it) => {
        it.remove();
      });
      n = 0;

      document.querySelector('.beliefs-form__top').classList.remove('hidden');
      scrollToElem(choiseParagraf, 'end');
    });
  }

  function scrollToElem(target, position) {
    target.scrollIntoView({ behavior: 'smooth', block: position });
  }
}

// -----------------------------------------------------
// -------------    driveScrollTo    ----------------
// -----------------------------------------------------

export function driveScrollTo() {
  let anchors = document.querySelectorAll('a[href*="#"]');

  for (let anchor of anchors) {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();

      const blockID = anchor.getAttribute('href').substring(1);

      document.getElementById(blockID)?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    });
  }
}

// -----------------------------------------------------
// -------------    modalGoAway    ----------------
// -----------------------------------------------------

export function modalGoAway() {
  let modal = document.querySelector('.modalGoAway'),
    closed = document.querySelectorAll('.closed'),
    button = document.querySelector('.modalGoAway__link'),
    html = document.documentElement;

  window.addEventListener('load', function () {
    sessionStorage.removeItem('modalOpen');
    return;
  });

  if (!modal || document.cookie.indexOf('telegram') != -1) {
    sessionStorage.removeItem('modalOpen');
    return;
  }

  /* Вывод модального окна при перемещении курсора за пределы сайта */
  function documentLeaveHandle() {
    if (
      !document.querySelector('.vbox-overlay') &&
      !document.querySelector('.popup__overlay_active')
    ) {
      sessionStorage.setItem('modalOpen', true);
      openModal();
    }
  }

  /* Вывод модального окна при неактивности более 10 сек */
  let timeout;
  function eventHandlerHiddenElement() {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      if (
        !document.querySelector('.vbox-overlay') &&
        !document.querySelector('.popup__overlay_active')
      ) {
        sessionStorage.setItem('modalOpen', true);
        openModal();
      }
    }, 60000);
  }

  setTimeout(() => {
    document.addEventListener('mouseleave', () => {
      if (
        !sessionStorage.getItem('modalOpen') &&
        !document.querySelector('.popup-active') &&
        !document.querySelector('.vbox-overlay') &&
        !document.querySelector('.popup__overlay_active')
      ) {
        documentLeaveHandle();
      }
    });
  }, 60000);

  // Обработчик для движения мыши
  document.addEventListener('mousemove', () => {
    if (
      !sessionStorage.getItem('modalOpen') &&
      !document.querySelector('.popup-active') &&
      !document.querySelector('.vbox-overlay') &&
      !document.querySelector('.popup__overlay_active')
    ) {
      eventHandlerHiddenElement();
    }
  });

  // Обработчик для прокрутки страницы
  document.addEventListener('scroll', () => {
    if (
      !sessionStorage.getItem('modalOpen') &&
      !document.querySelector('.popup-active') &&
      !document.querySelector('.vbox-overlay') &&
      !document.querySelector('.popup__overlay_active')
    ) {
      eventHandlerHiddenElement();
    }
  });

  if (window.innerWidth <= 768) {
    setTimeout(() => {
      if (
        !sessionStorage.getItem('modalOpen') &&
        !document.querySelector('.popup-active') &&
        !document.querySelector('.vbox-overlay') &&
        !document.querySelector('.popup__overlay_active')
      ) {
        sessionStorage.setItem('modalOpen', true);
        openModal();
      }
    }, 90000);
  }

  button.addEventListener('click', () => {
    if (button.href.includes('t.me')) {
      document.cookie = 'telegram=true; max-age=2592000; path=/';
    }
  });

  /* Открытие модального окна */
  function openModal() {
    modal.nextElementSibling.classList.add('modalGoAwayOpen');
    modal.classList.add('modalGoAway-active');
    html.classList.add('scroll-lock');
  }

  /* Закрытие модального окна */
  closed.forEach((it) => {
    it.addEventListener('click', () => {
      modal.nextElementSibling.classList.remove('modalGoAwayOpen');
      modal.classList.remove('modalGoAway-active');
      html.classList.remove('scroll-lock');
    });
  });
}

// -----------------------------------------------------
// -------------    tabooCopy    ----------------
// -----------------------------------------------------

export function tabooCopy() {
  document.addEventListener('copy', function (e) {
    e.preventDefault();
    window.location.href = '/';
  });
}
